// extracted by mini-css-extract-plugin
module.exports = {"Table":"Events_Table__2AUWM"};